
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mindsetReportApi } from '@/api/MindsetReportApi';
import { MindsetReportModel } from '@/models/mindset/MindsetReportModel';
import { MindsetError, RyzerType } from "@/../types/constants/ryzer"
import { GetMindsetArchetype } from '@/../types/constants/ryzer';

@Component({
	render(h){
		return h(
			this.as,
			this.$slots.default ? this.$slots.default : this.$scopedSlots.default(this.SlotProps)
		);
	}
})
export default class MindsetProvider extends Vue{
	@Prop({ default: 'div' }) private as: string;
	@Prop() private profileId: string;

	hasMindset: boolean = false;
	loadingMindset: boolean = false;
	mindsetReport: MindsetReportModel = undefined;
	mindsetType: RyzerType = undefined;
	archetype: string = '';
	error: string = '';
	mindsetDays: number = 9999;
	noUser: boolean = false;
	noTest: boolean = false;

	get SlotProps(): { hasMindset: boolean, loadingMindset: boolean, archetype: string, mindsetReport: MindsetReportModel, mindsetType: RyzerType, noUser: boolean, noTest: boolean, error: string, mindsetDays: number } {
		return {
			hasMindset: this.hasMindset,
			loadingMindset: this.loadingMindset,
			archetype: this.archetype,
			mindsetReport: this.mindsetReport,
			mindsetType: this.mindsetType,
			noUser: this.noUser,
			noTest: this.noTest,
			error: this.error,
			mindsetDays: this.mindsetDays,
		};
	}

	created(): void {
		this.loadMindset();
	}

	// watch the profileId prop. if it changes, load the profile
	@Watch('profileId')
	loadMindset(): void{
		if( !this.profileId ) return;

		this.lookupProfile( this.profileId );
	}

	async lookupProfile(profileId: string): Promise<MindsetReportModel>{
		if( !profileId ) return;

		this.loadingMindset = true;
		this.mindsetReport = await mindsetReportApi.findById(profileId);
		if( !!this.mindsetReport ) {
			this.hasMindset = this.mindsetReport.error == '' && this.mindsetReport.archetype != '';
			this.archetype = this.mindsetReport.archetype;
			this.error = this.mindsetReport.error;
			this.noUser = this.mindsetReport.error.indexOf(MindsetError.RyzerUserDoesNotExist) >= 0;
			this.noTest = this.mindsetReport.error.indexOf(MindsetError.RyzerUserNoTAP) >= 0;
			this.mindsetDays  = this.mindsetReport.DaysSinceAssessment;
		}

		this.mindsetType = GetMindsetArchetype(this.archetype);
		this.loadingMindset = false;
		return this.mindsetReport;
	}
}
